import React, { ReactNode } from "react";
import { Card, CardSize } from ".";
import { Colors } from "../../Constants/colors";

interface SubCardProps {
  children: ((index: number) => ReactNode) | ReactNode;
  subCardSize?: CardSize;
  subCardTitle?: string;
  onAddCard?: () => unknown;
  onRemoveCard?: (index: number) => unknown; // Pass the index to onRemoveCard
  canAddCard?: boolean;
  canRemoveCard?: boolean;
  totalCard?: number;
  wrapperStyle?: object;
}

export const SubCard = ({
  subCardSize = CardSize.md,
  subCardTitle = "",
  children,
  onAddCard,
  onRemoveCard,
  totalCard = 1,
  wrapperStyle = {},
}: SubCardProps) => {
  return (
    <div>
      {Array.from({ length: totalCard ? totalCard : 1 }, (_, index) => (
        <Card
          key={index} // Add a unique key for each Card
          cardSize={subCardSize}
          cardTitle={subCardTitle}
          titleStyle={styles.titleStyle}
          wrapperStyle={{ ...styles.wrapperStyle, ...wrapperStyle }}
          onAddCard={
            onAddCard && index + 1 === totalCard ? onAddCard : undefined
          }
          onRemoveCard={
            onRemoveCard && totalCard > 1
              ? () => onRemoveCard(index)
              : undefined
          }
          totalCard={totalCard ? totalCard : 1}
        >
          {typeof children === "function" ? children(index) : children}
        </Card>
      ))}
    </div>
  );
};

const styles = {
  titleStyle: {
    fontSize: 20,
  },
  wrapperStyle: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    backgroundColor: Colors.White,
  },
};
